const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

/** Short console line for a socket frame. Omits tokens and record bodies. */
export const summariseFrame = (message: unknown): Record<string, unknown> => {
  if (!isRecord(message)) {
    return { shape: typeof message };
  }

  const data = isRecord(message.data) ? message.data : undefined;
  const body = data && isRecord(data.data) ? data.data : undefined;

  return {
    action: message.action ?? null,
    type: data?.type ?? null,
    correlationId: data?.correlationId ?? null,
    resource: body?.resource ?? null,
    hasPrimaryKey: typeof body?.primaryKey === "string" && body.primaryKey.length > 0,
  };
};

export { isRecord };
